import { LitElement, html, utils } from '@hh/global.js'

class HHHeader extends LitElement {
  constructor() {
    super()

    this.setWindowsHeight()
    window.addEventListener('resize', () => this.setWindowsHeight())
  }

  closeOpenModals(e) {
    utils.all('hh-details-modal', this).map((element) => {
      if (element !== e.detail.value) {
        element.setAttribute('open', false)
      }
    })
  }

  setWindowsHeight() {
    document.documentElement.style.setProperty(
      '--header-height',
      `${this.offsetHeight}px`
    )
    document
      .querySelector('html')
      .style.setProperty('--hh-window-height', `${window.innerHeight}px`)
    const announcementBar = document.querySelector('.announcement-bar')
    if (announcementBar)
      document.documentElement.style.setProperty(
        '--announcement-height',
        `${announcementBar.offsetHeight}px`
      )
  }

  toggleCart(e) {
    e?.detail?.event?.preventDefault()
    utils.toggle(document.body, ['mini-cart-is-active'])
  }

  render() {
    return html`<slot
      @modalOpened="${this.closeOpenModals}"
      @toggleCart="${this.toggleCart}"
    ></slot>`
  }
}

customElements.define('hh-header', HHHeader)

class HHHeaderSubmenu extends LitElement {
  constructor() {
    super()

    this.detailsEl = this.querySelector('details')
    this.summaryEl = this.querySelector('summary')
    this.closeButtonEl = this.querySelector('[data-close-details]')
  }

  connectedCallback() {
    super.connectedCallback()
    this.summaryEl.addEventListener('click', this.handleSummaryClick.bind(this))
    this.closeButtonEl.addEventListener('click', this.closeSubmenu.bind(this))
  }

  handleSummaryClick() {
    const parentMenuElement = this.detailsEl.closest('.has-submenu')

    this.detailsEl.classList.add('menu-opening')
    parentMenuElement && parentMenuElement.classList.add('submenu-open')
  }

  closeSubmenu() {
    this.detailsEl.classList.remove('menu-opening')

    const parentMenuElement = this.detailsEl.closest('.has-submenu')
    parentMenuElement && parentMenuElement.classList.remove('submenu-open')

    setTimeout(() => {
      this.detailsEl.removeAttribute('open')
    }, 300)
  }

  render() {
    return html`<slot></slot>`
  }
}

customElements.define('hh-header-submenu', HHHeaderSubmenu)
